import { createReducer } from '../../../store.model';

import { ActionType } from './bl-dialog.action';
import { BlDialogState, defaultState } from './bl-dialog.state';
import {
    ListDocuments,
    ListDocumentsResult,
} from './state/list-documents.action';
import {
    listDocumentsReducer,
    listDocumentsResultReducer,
} from './state/list-documents.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';

const { builder, reducer } = createReducer<ActionType, BlDialogState>(
    defaultState(),
);

builder.add<Reload>(ActionType.COACHING__BL__RELOAD, reloadReducer);
builder.add<ReloadResult>(
    ActionType.COACHING__BL__RELOAD_RESULT,
    reloadResultReducer,
);

builder.add<ListDocuments>(
    ActionType.COACHING__BL__LIST_DOCUMENTS,
    listDocumentsReducer,
);
builder.add<ListDocumentsResult>(
    ActionType.COACHING__BL__LIST_DOCUMENTS_RESULT,
    listDocumentsResultReducer,
);

export const blDialogReducer = reducer;
